import PartsTable from './PartsTable'
export default PartsTable
